/**
 * Compact number formatting for pool sizes ("21.4k", "1.2M").
 * For Media Devoted | Created By Ciro Autiero
 */
export function formatCompact(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  if (Math.abs(value) >= 1_000_000)
    return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (Math.abs(value) >= 1_000)
    return `${(value / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(value);
}
